import React from "react";
import DefaultScreen from "@components/Global/DefaultScreenView";
import { Text, Platform, View } from "react-native";
import getPackageList from '@utils/getPackageList';
import IndividualDataTable from "../../LowLevel/Components/DataTable";
import { Title } from "@constants/Themed";

const CreditsScreen = () => {
  const packageList = getPackageList();

  // Transform each item into an object with properties: index, package_name, url
  const transformedPackageList = packageList.map((packageName, index) => ({
    index: { data: index + 1, width: 50 }, // Adding 1 to start the index from 1
    package_name: packageName,
    url: { data: `https://www.npmjs.com/package/${packageName}`, width: 400 }, // Assuming npm package, you may need to adjust for other package managers
  }));


  return (
    <DefaultScreen containerStyle={{ gap: 20 }}>
      <View style={{ minHeight: 200, borderRadius: 20, shadowRadius: 20, shadowOpacity: .2, backgroundColor: 'white', justifyContent: "center", alignSelf: "stretch", padding: 20, marginVertical: 20 }}>
        <Title style={{ textAlign: 'center' }}>Credits Screen</Title>
      </View>
      {Platform.OS === 'web' ? (
        <IndividualDataTable clickFunction={(data) => console.log('data is', data)} dataArray={transformedPackageList} />
      ) : (
        <Text>Not Web</Text>
      )}
    </DefaultScreen>
  );
};

export default CreditsScreen;
